import React from "react"

interface SectionTitleProps {
  text: string
  variant?: "light" | "dark"
  className?: string
  /** If provided, split the text after this many words and highlight the remainder. If omitted, default behavior highlights the last word. */
  splitAt?: number
}

export default function SectionTitle({ text, variant = "light", className = "", splitAt }: SectionTitleProps) {
  const parts = text.trim().split(/\s+/)
  let rest = ''
  let last = ''
  // If splitAt is provided and useful, highlight the remainder after splitAt words.
  if (typeof splitAt === 'number' && splitAt > 0) {
    if (parts.length > splitAt) {
      rest = parts.slice(splitAt).join(' ')
      last = ''
      // keep head as the leading words (rendered as rest of the heading)
    } else {
      // Not enough words to split; fall back to highlighting the last word (original behavior)
      last = parts.pop() ?? ''
      rest = parts.join(' ')
    }
  } else {
    // Default behavior: highlight last word
    last = parts.pop() ?? ''
    rest = parts.join(' ')
  }
  const base = variant === "dark" ? "text-white" : "text-black"
  return (
    <h2 className={`text-3xl md:text-4xl font-bold ${base} ${className}`} style={{ fontFamily: 'DIN, sans-serif' }}>
      {rest && <span>{rest} </span>}
      {last ? (
        variant === "light" ? (
          <span className="bg-[#fb0009] text-white px-2 md:px-3 py-1 md:py-2 inline-block">{last}</span>
        ) : (
          <span className="text-[#fb0009]">{last}</span>
        )
      ) : (
        // If there is no `last` (we used splitAt), highlight the `rest` portion instead
        rest ? (
          variant === "light" ? (
            <span className="bg-[#fb0009] text-white px-2 md:px-3 py-1 md:py-2 inline-block">{rest}</span>
          ) : (
            <span className="text-[#fb0009]">{rest}</span>
          )
        ) : null
      )}
    </h2>
  )
}
